<template>
  <section class="main-page">
    <div class="text-main container">
      <p>
        Votre nouveau rendez-vous gourmand, où la convivialité se partage et se
        déguste.
      </p>
      <router-link class="btn-menu" :to="{ name: 'menu' }"
        >voir le menu</router-link
      >
    </div>
  </section>
  <div class="line">
      <p>Ouvert tout les jours | <strong>12h - 14h / 19h - 21h</strong></p>
  </div>
  <section class="text-about container">
    <div class="text-container">
      <h2>Des plats fait maison, avec des produits locaux</h2>
      <br />
      <br />
      <table class="listing">
        <tbody>
          <tr>
            <td><i class="fa-solid fa-leaf"></i></td>
            <td>
              <p>
                Quel que soit votre goût, nous avons quelque chose pour vous.
              </p>
            </td>
          </tr>
          <tr>
            <td><i class="fa-solid fa-location-dot"></i></td>
            <td>
              <p>
                Nous nous engageons à privilégier les produits locaux et
                régionaux dans notre carte.
              </p>
            </td>
          </tr>
          <tr>
            <td><i class="fa-solid fa-wine-bottle"></i></td>
            <td>
              <p>
                Laissez-vous tenter par une bière ou un cocktail dans
                l'atmosphère relaxante de notre espaces détente.
              </p>
            </td>
          </tr>
        </tbody>
      </table>
      <router-link class="btn-menu" :to="{ name: 'menu' }"
        >Voir le menu</router-link
      >
    </div>
    <div class="collage" v-show="!mobile">
      <img src="../assets/Pizza.jpg" alt="" class="img pizza" />
      <img src="../assets/Cocktail.jpg" alt="" class="img cocktail" />
      <img src="../assets/Burger.jpg" alt="" class="img burger" />
      <img src="../assets/Calzone.jpg" alt="" class="img calzone" />
    </div>
  </section>
</template>

<script>
import { useHead } from '@vueuse/head'
import { organizationSchema, injectSchema, breadcrumbSchema } from '@/utils/seoConfig'

export default {
  name: "HomeView",
  components: {},
  setup() {
    useHead({
      title: 'La Pizza du Lac - Accueil',
      meta: [
        {
          name: 'description',
          content: 'Bienvenue à La Pizza du Lac. Découvrez nos délicieuses pizzas, burgers et cuisine italienne préparés avec des produits locaux. Ouvert tous les jours de 12h à 14h et 19h à 21h.'
        },
        {
          property: 'og:title',
          content: 'La Pizza du Lac - Accueil'
        },
        {
          property: 'og:description',
          content: 'Découvrez nos délicieuses pizzas, burgers et cuisine italienne préparés avec des produits locaux.'
        },
        {
          property: 'og:type',
          content: 'website'
        }
      ]
    })
  },
  data() {
    return {
      mobile: null,
      windowWidth: null,
    };
  },
  mounted() {
    // Injecter les schemas JSON-LD
    injectSchema(organizationSchema)
    injectSchema(breadcrumbSchema([
      { name: 'Accueil', url: 'https://lapizzadulac.com/' }
    ]))
  },
  created() {
    window.addEventListener("resize", this.checkScreen);
    this.checkScreen();
  },
  methods: {
    checkScreen() {
      this.windowWidth = window.innerWidth;
      if (this.windowWidth <= 900) {
        this.mobile = true;
        return;
      }
      this.mobile = false;
    },
  },
};
</script>

<style lang="scss" scoped>
.main-page {
  width: 100%;
  height: 70vh;
  padding: 70px;
  background-image: url("../assets/Gauffre-resize.jpg");
  background-size: cover;
  background-attachment: fixed;
  position: relative;
  align-content: center;
  @media (min-width: 800px) {
    background-position-y: -200px;
  }
  @media (max-width: 800px) {
    background-position-x: -700px;
  }

  img {
    object-fit: cover;
    height: 100%;
    width: 100%;
  }

  p {
    margin-top: 100px;
    font-size: clamp(32px, 8vw, 80px);
    color: rgb(255, 255, 255);
    backdrop-filter: blur(6px);
    border-radius: 24px;
  }
}
.btn-menu {
  position: relative;
  top: 20px;
  margin-top: 100px;
  padding: 15px;
  text-decoration: none;
  background-color: #232eff;
  color: white;
  border-radius: 24px;
  font-size: 16px;
  box-shadow: 6px 6px 5px rgba(0, 0, 0, 0.226);
  @media (max-width: 800px) {
    width: 100px;
    height: 40px;
    font-size: 12px;
  }
}

.line {
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  height: 40px;
  background-color: #fff;
}

.text-about {
  justify-content: center;
  display: flex;
  padding: 30px;
  max-width: 100%;
  background-color: #ffcc85;
  align-items: center;
  .text-container {
    margin-left: 40px;
    text-align: left;
    width: 40vw;
    @media (max-width: 900px) {
      margin-left: 0;
      width: 100%;
    }

    h2 {
      font-size: clamp(28px, 6.5vw, 38px);
      font-weight: lighter;
    }
    .first-text {
      padding: 10px;
      font-size: clamp(8px, 2.7vw, 17px);
    }
  }
  .listing {
    justify-content: space-between;

    i {
      font-size: 24px;
    }
    p {
      padding: 10px;
      font-size: clamp(12px, 3vw, 20px);
      font-weight: 600;
    }
  }
}

.collage {
  margin-left: 250px;
  position: relative;
  width: 600px;
  height: 600px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.img {
  position: absolute;
  border-radius: 20px;
  border: 2px solid #ffffff;
  box-shadow: 5px 5px 15px rgba(0, 0, 0, 0.2);
}

.pizza {
  width: 220px;
  z-index: 2;
  top: 10px;
  left: 20px;
}
.calzone {
  width: 150px;
  z-index: 3;
  top: 30px;
  right: 40px;
}
.burger {
  width: 200px;
  z-index: 2;
  bottom: 50px;
  left: 10px;
}
.cocktail {
  width: 300px;
  z-index: 1;
}
</style>
